import actionTypes from "./actionTypes";

export const changeRole = data => {
  return {
    type: actionTypes.CHANGE_ROLE,
    payload: data
  };
};

export const getGhostingCompanies = () => {
  return {
    type: actionTypes.GHOSTING_COMPANIES
  };
};

export const resetRole = () => {
  return {
    type: actionTypes.RESET_ROLE
  };
};